import template from './stPassengers.html';
import templateView from './stPassengers-view.html';
import controller from './stPassengers.controller';

let stPassengersComponent = {
    restrict: 'E',
    bindings: {
        data: '=',
        index: '='
    },
    template: function ($element, $attrs) {
        'ngInject';
        return $attrs.editable == "true" ? template : templateView;
    },
    controller,
    controllerAs: 'vm'
};

export default stPassengersComponent;



// WEBPACK FOOTER //
// ./client/app/common/stPassengers/stPassengers.component.js